import React, { useState, useEffect } from 'react'
import MerchantHeader from './components/MerchantHeader'
import MerchantTable from './components/MerchantTable'
import ManageTableGrid from './components/MerchantTableGrid';
import ManageTable from './components/ManageTable';
import DashboardHeader from './components/DashboardHeader'
import { merchantManagement } from "../../config/LiveApi";
import { useSelector } from 'react-redux';

function MerchantManagement() {

  let token = useSelector(store => store.userReducer.token);
  const [inData, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [viewType, setViewType] = useState('list');

  useEffect(() => {
    const now = new Date();

    now.setHours(0, 0, 0, 0);
    const isoDateString = now.toISOString();

    //     console.log(isoDateString);

    const nowDays = new Date();
    const isoDateCurrent = nowDays.toISOString();
    // const isoDateStringCurrent = now.toISOString();



    setStartDate(isoDateString);
    setEndDate(isoDateCurrent);



    merChantData(token, isoDateString, isoDateCurrent);
  }, []);

  const merChantData = async (token, startDate, endDate) => {
    setIsLoading(true);
    const data = await merchantManagement(token, startDate, endDate);

    setData(data);
    setIsLoading(false);
  };

  return (
    <div>
      <MerchantHeader />
      <DashboardHeader startDate={startDate} endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate} merChantData={merChantData} />

      <div className="table-list-select">
        <div>
          <p className="overview" style={{ marginLeft: '10px' }}>
            Select View :
            <span>
              <button 
                className={`check-provider-details ${viewType === 'list' ? 'active' : ''}`} 
                onClick={() => setViewType('list')}
              >
                List View
              </button>
            </span>
            <span>
              <button 
                className={`check-provider-details ${viewType === 'grid' ? 'active' : ''}`} 
                onClick={() => setViewType('grid')}
              >
                Grid View
              </button>
            </span>
          </p>
        </div>
      </div>

      <div>
      {viewType === 'list' ? (
          <MerchantTable inData={inData} isLoading={isLoading} startDate={startDate} endDate={endDate} />
        ) : (
          <ManageTableGrid inData={inData} isLoading={isLoading} startDate={startDate} endDate={endDate} />
        )}
      </div>
    </div>
  )
}

export default MerchantManagement
